import './Button.css'

export default ({children})=>{
    return <button className="button">{children}</button>
}